<template>
  <WdsText
    v-if="client.trusted"
    small
    primary
    :title="$t('Trusted clients cannot be revoked. Please contact Worksome if this is required.')"
  >
    {{ $t('Active') }}
  </WdsText>
  <template v-else-if="!client.revoked">
    <WdsButtonText @click="showRevokeConfirmation">
      <WdsText small primary :title="revokeTitle">
        {{ $t('Revoke') }}
        <span class="tw-sr-only">, "{{ client.name }}"</span>
      </WdsText>
    </WdsButtonText>

    <ConfirmationModal
      :show="confirmationModal.isVisible.value"
      :title="$t('Revoke Client')"
      :description="$t('Are you sure you want to revoke this client?')"
      :confirm-text="$t('Revoke')"
      :cancel-text="$t('Cancel')"
      :loading="confirmationModal.isLoading.value"
      @confirm="confirmationModal.handleConfirm"
      @cancel="confirmationModal.handleCancel"
    />
  </template>
  <WdsText v-else error>{{ $t('Revoked') }}</WdsText>
</template>

<script setup lang="ts">
import { WdsButtonText, WdsText } from '@worksome/wds-components'
import axios from 'axios'
import ConfirmationModal from '@/components/Common/ConfirmationModal.vue'
import { $t } from '@/composables/translation'
import { useConfirmationModal } from '@/composables/useConfirmationModal'
import type { OAuthClient } from '@/components/api/types'

interface Props {
  client: OAuthClient
}

const props = defineProps<Props>()

const emit = defineEmits<{
  revoked: [clientName: string]
}>()

const confirmationModal = useConfirmationModal()

const revokeTitle = $t('Revoke ":instance"', { instance: props.client.name })

function showRevokeConfirmation(): void {
  confirmationModal.showConfirmation({
    title: $t('Revoke Client'),
    message: $t('Are you sure you want to revoke this client?'),
    confirmText: $t('Revoke'),
    cancelText: $t('Cancel'),
    type: 'error',
    onConfirm: async () => {
      await axios.delete(`/oauth/clients/${props.client.id}`)
      emit('revoked', props.client.name)
    },
  })
}
</script>
